module.exports = __webpack_public_path__ + "img/0030.6716f349.jpg";